import { CreateStudentDebtReferenceResultType, CreateStudentDebtReferenceType, StudentDebtTotalType, StudentDebtType, StudentPaymentReportQueryType, StudentPaymentReportType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { del, get, post, put } from "../../utils/axios-config";
import { GENERATE_STUDENT_DEBTIES_REFERENCES, GET_MONTHSPAYMENTS, IRREGULAR_STUDENT_DEBTIES, STUDENT_DEBTIES, STUDENT_DEBTIES_BY_ENROLLMENTS, STUDENT_DEBTIES_BY_SUBSCRIPTIONS, STUDENT_DEBTS_TOTAL_BY_STUDENT_ID } from "../../utils/constants";

export const createStudentDebt = async (data: StudentDebtType) => await post<StudentDebtType, string>(STUDENT_DEBTIES, data);
export const updateStudentDebt = async (data: StudentDebtType) => await put<StudentDebtType, string>(STUDENT_DEBTIES, data);
export const getStudentDebt = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdPaymentType ? { IdPaymentType: data.IdPaymentType } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),
        ...(data?.Id ? { Id: data.Id } : {}),

    });
    const url = `${STUDENT_DEBTIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentDebtType>>(url)
};

export const getIrregularStudentDebt = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdPaymentType ? { IdPaymentType: data.IdPaymentType } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),
        ...(data?.Id ? { Id: data.Id } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.CourseLevel ? { CourseLevel: data.CourseLevel } : {}),
    });
    const url = `${IRREGULAR_STUDENT_DEBTIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentDebtType>>(url)
};

export const getIrregularStudentDebtByStudentsClass = async (data: PagedRequestType) => {

    return await post<PagedRequestType , PagedResultsType<StudentDebtType>>(IRREGULAR_STUDENT_DEBTIES, data);
};

export const getStudentDebtTotalByStudentId = async (idStudent: PagedRequestType) => {
   
    const url = `${STUDENT_DEBTS_TOTAL_BY_STUDENT_ID}/${idStudent}`;
    return await get<StudentDebtTotalType>(url)
};

export const getStudentDebtsByEnrollment = async (id: string) => {
    const url = `${STUDENT_DEBTIES_BY_ENROLLMENTS}/${id}`;
    return await get<StudentDebtType[]>(url)
};
export const getStudentDebtsBySubscription = async (id: string) => {
    const url = `${STUDENT_DEBTIES_BY_SUBSCRIPTIONS}/${id}`;
    return await get<StudentDebtType[]>(url)
};
export const deleteStudentDebt = async (data: {id: string}) => await del<{id: string}, boolean>(STUDENT_DEBTIES, data);


export const createStudentDebtReferences = async (data: CreateStudentDebtReferenceType) => await post<CreateStudentDebtReferenceType, CreateStudentDebtReferenceResultType[]>(GENERATE_STUDENT_DEBTIES_REFERENCES, data);

export const getMonthPayments = async (data:StudentPaymentReportQueryType) => {
    return await post<StudentPaymentReportQueryType , StudentPaymentReportType[]>(GET_MONTHSPAYMENTS, data);
};